export interface UserSession {
  isLoggedIn: boolean;
  fullName: string;
  idToken: string;
}

export const emptyUserSession: UserSession = {
  isLoggedIn: false,
  fullName: "",
  idToken: ""
};
